import {Injectable} from '@angular/core';
const Dot = require('dot-object');

@Injectable({
  providedIn: 'root',
})
export class FormToObjectUtilService {
  constructor() {}

  convertToObject(res) {
    const dot = new Dot('__');
    dot.object(res);
    return res;
  }
}
